import { Expose } from 'class-transformer';

import { Default } from '@lib/common/decorators';
import { SnModel } from '@lib/common/models';

export class FsPolicy extends SnModel {
  @Expose()
  public id: string;

  @Expose()
  public permissions: any[] = [];

  @Expose()
  public isSystemManaged: boolean;

  @Expose()
  public isOrganizationManaged: boolean;

  @Expose()
  public name: string;

  @Expose()
  public isDenyPolicy: boolean;

  @Expose()
  @Default([])
  public resources: any[];

  @Expose()
  public conditions: any;

  @Expose()
  public createdTimestamp: Date;

  @Expose()
  public updatedTimestamp: Date;

  public cameras: any[] = [];

  public locations: any[] = [];

  public layers: any[] = [];

  public tags: any[] = [];

  public selectAll: boolean = false;

  get type(): string {
    const resource = this.resources[0];
    const cameraPermissions = ['cameras.view_camera'];
    const locationPermissions = ['cameras.view_camera', 'maps.view_location'];
    const cameraTagPermissions = ['cameras.view_camera'];
    const locationTagPermissions = ['cameras.view_camera', 'maps.view_location'];
    const layerPermissions = ['maps.Layer'];
    const allPermissions = [];
    if (resource) {
      if (
        (resource.type === 'cameras.Camera' && !!resource.id_In) ||
        this.allResources(cameraPermissions)
      ) {
        return 'camera';
      }
      if (
        (resource.type === 'cameras.Camera' && !!resource.location_In) ||
        this.allResources(locationPermissions)
      ) {
        return 'location';
      }
      if (
        (resource.type === 'cameras.Camera' && !!resource.tagRecords_Tag_Id_In) ||
        this.allResources(cameraTagPermissions)
      ) {
        return 'Camera Tag';
      }
      if (
        (resource.type === 'cameras.Camera' && !!resource.location_TagRecords_Tag_Id_In) ||
        this.allResources(locationTagPermissions)
      ) {
        return 'Location Tag';
      }
      if (
        (resource.type === 'maps.Layer' && !!resource.id__in) ||
        this.allResources(layerPermissions)
      ) {
        return 'layer';
      }
      if (
        (resource.type === 'Permission' && !!resource.id__in) ||
        this.allResources(allPermissions)
      ) {
        return 'permission';
      }
    }
    return 'permission';
  }

  constructor(data: any = {}) {
    super();

    this.fromJSON(data);
  }

  public allResources(permissionsToCheck: any[]): boolean {
    return (
      this.resources.includes('*') &&
      permissionsToCheck.length === this.permissions.length &&
      permissionsToCheck.every((element, index) => {
        return element === this.permissions[index];
      })
    );
  }
}
